import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignupOtpComponent } from './signup-otp/signup-otp.component';
import { RouterModule } from '@angular/router';
import { signupRoutes } from './signup.route';
import { NgOtpInputModule } from 'ng-otp-input';
import { NzStatisticModule, NzTabsModule } from 'ng-zorro-antd';
import { SignupPhoneComponent } from './signup-phone/signup-phone.component';
import { MatInputModule } from '@angular/material/input';
import { SignupFormComponent } from './signup-form/signup-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SignupWarningComponent } from './signup-warning/signup-warning.component';
import { SignupCardComponent } from './signup-card/signup-card.component';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatRadioModule } from '@angular/material/radio';
import { SharedCommonModule } from '../../shared/shared-common.module';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { CreditCardDirectivesModule } from 'angular-cc-library';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    SignupOtpComponent,
    SignupPhoneComponent,
    SignupFormComponent,
    SignupWarningComponent,
    SignupCardComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(signupRoutes),
    NgOtpInputModule,
    NzStatisticModule,
    NzTabsModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatListModule,
    MatExpansionModule,
    MatRadioModule,
    SharedCommonModule,
    NgxMaskModule.forRoot(maskConfig),
    CreditCardDirectivesModule
  ],
  exports: [
    SignupOtpComponent,
    SignupPhoneComponent,
    SignupFormComponent]
})
export class SignupModule {
}
